import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wuxu2",
  "use": "icon-wuxu2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wuxu2\"><path d=\"M512 0C229.205 0 0 229.248 0 512s229.205 512 512 512c282.752 0 512-229.248 512-512S794.752 0 512 0zM73.13 512C73.13 269.653 269.61 73.173 512 73.173c102.997 0 197.461 35.712 272.341 95.104L166.016 781.312A436.565 436.565 0 0 1 73.131 512zM512 950.87c-110.677 0-211.499-41.26-288.683-108.843L844.8 226.432a436.779 436.779 0 0 1 106.07 285.61C950.87 754.39 754.39 950.87 512 950.87z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol